<template>
  <div class="check-confirm">
    <selfcheck-calling-modal :visible="isCalling" @cancel="handleCallStaffCancel" />
    <selfcheck-unhandled-error-modal :visible="hasUnhandledError" @backtotop="handleBackToTop" />
    <selfcheck-browser-back-modal
      :visible="isShowingBrowserBackModal"
      @confirm="handleBrowserBackConfirm"
      @cancel="handleBrowserBackCancel"
    />
    <amount-changed-modal :visible="isShowingAmountChangedModal" @close="handleClose" />
    <selfcheck-progress class="selfcheck-progress" :active-index="1" />

    <div class="check-details-wrap">
      <check-details
        :title="$t('selfcheck.accountingConfirmation')"
        :check-infos="checkInfos"
        :tax-amount="taxAmount"
      />
    </div>
    <selfcheck-button-footer class="footer">
      <li>
        <so-button @click="handleCancel">{{ $t('common.cancel') }}</so-button>
      </li>
      <li>
        <so-button variant="red" @click="handleNext">{{ $t('common.check') }}</so-button>
      </li>
    </selfcheck-button-footer>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import SoButton from '@/components/common/SoButton'
import SelfcheckButtonFooter from '@/components/selfcheck/SelfcheckButtonFooter'
import SelfcheckProgress from '@/components/selfcheck/SelfcheckProgress'
import CheckDetails from '@/components/selfcheck/CheckDetails'
import SelfcheckCallingModal from '@/components/modal/SelfcheckCallingModal'
import SelfcheckUnhandledErrorModal from '@/components/modal/SelfcheckUnhandledErrorModal'
import SelfcheckBrowserBackModal from '@/components/modal/SelfcheckBrowserBackModal'
import AmountChangedModal from '@/components/modal/AmountChangedModal'

export default {
  name: 'CheckConfirm',
  components: {
    SoButton,
    SelfcheckButtonFooter,
    SelfcheckProgress,
    CheckDetails,
    SelfcheckCallingModal,
    SelfcheckUnhandledErrorModal,
    SelfcheckBrowserBackModal,
    AmountChangedModal,
  },
  data() {
    return {
      isCalling: false,
      isCanceled: false,
      isShowingBrowserBackModal: false,
      isShowingAmountChangedModal: false,
      hasUnhandledError: false,
    }
  },
  computed: {
    ...mapGetters({
      seatStatus: 'seat/getSeatStatus',
      taxAmount: 'selfcheck/getTaxAmount',
      checkInfos: 'selfcheck/getCheckInfos',
      isAmountChanged: 'selfcheck/getIsAmountChanged',
      isFetching: 'selfcheck/getIsFetching',
      error: 'selfcheck/getError',
    }),
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
  },
  watch: {
    seatStatus() {
      if (this.seatStatus === 4) {
        this.isCalling = true
      }
      if (this.seatStatus === 0) {
        this.isCanceled = true
        this.$router.replace({ name: 'shopMenu' })
      }
    },
  },
  mounted() {
    // mountedの時点で呼出中の場合 = セルフチェック中ユーザーの呼出中のリロード
    if (this.seatStatus === 4) {
      this.isCalling = true
    }
  },
  beforeRouteLeave(to, _from_, next) {
    // 遷移先が次のページなら常に成功
    if (to.name === 'check') {
      next()
      return
    }
    // キャンセルされていたら離脱
    if (this.isCanceled) {
      next()
      return
    }
    // それ以外（ブラウザバック）の際はモーダルを表示
    this.showBrowserBackModal()
    next(false)
  },
  methods: {
    ...mapActions({
      confirmSelfcheck: 'selfcheck/confirmSelfcheck',
      cancelSelfcheck: 'selfcheck/cancelSelfcheck',
      setShowingSimpleErrorModal: 'modal/setShowingSimpleErrorModal',
      setShowingSelfcheckErrorModal: 'modal/setShowingSelfcheckErrorModal',
    }),
    async handleNext() {
      await this.confirmSelfcheck()

      if (!this.error) {
        if (this.isAmountChanged) {
          this.isShowingAmountChangedModal = true
        } else {
          this.$router.replace({ name: 'check' })
        }
      } else {
        if (this.error.response) {
          if (this.error.response.status === 503) {
            this.isCalling = true
          } else {
            this.hasUnhandledError = true
          }
        } else {
          this.setShowingSimpleErrorModal(true)
        }
      }
    },
    async cancel(callStaff) {
      await this.cancelSelfcheck({ callStaff })

      if (!this.error) {
        this.isCanceled = true
        this.$router.replace({ name: 'shopMenu' })
      } else {
        if (this.error.response) {
          this.setShowingSelfcheckErrorModal(true)
        } else {
          this.setShowingSimpleErrorModal(true)
        }
      }
    },
    handleCancel() {
      this.cancel(true)
    },
    handleCallStaffCancel() {
      this.cancel(false)
    },
    handleBackToTop() {
      this.cancel(true)
    },
    handleClose() {
      this.isShowingAmountChangedModal = false
    },
    async handleBrowserBackConfirm() {
      await this.cancel(false)
      this.hideBrowserBackModal()
    },
    handleBrowserBackCancel() {
      this.hideBrowserBackModal()
    },
    showBrowserBackModal() {
      this.isShowingBrowserBackModal = true
    },
    hideBrowserBackModal() {
      this.isShowingBrowserBackModal = false
    },
  },
  head: {
    title() {
      return {
        inner: this.isUs
          ? '$ ' + this.$t('selfcheck.paymentConfirm')
          : this.$t('selfcheck.paymentConfirm'),
        complement: this.$t('siteId'),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.check-confirm {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 15px 15px 0;
}
.selfcheck-progress,
.footer {
  flex-shrink: 0;
}
.check-details-wrap {
  flex-grow: 1;
  flex-shrink: 0;
}
</style>
